export default __webpack_public_path__ + "static/media/ic_cash_out.c617c605.svg";